import React from "react";

import { IUnitType } from "shared/types";
import { useUnitType, DistanceUnits } from "shared/utils";

import { Distance as DistanceComponent } from "../components/Distance";

interface DistanceProps {
  distance: number;
}

export const Distance: React.FC<DistanceProps> = ({ distance }) => {
  const { unitType } = useUnitType();

  return (
    <DistanceComponent
      distance={distance}
      toUnit={unitType === IUnitType.metric ? DistanceUnits.m : DistanceUnits.ft}
    />
  );
};
